/* Patina Circle: localize the observed same-origin Rivo drawer only. */
(() => {
  'use strict';
  let locale = document.documentElement.lang || '';
  try {
    locale = JSON.parse(document.getElementById('PS8Config')?.textContent || '{}').locale || locale;
  } catch (_) { /* The document language remains a safe fallback. */ }
  if (!/^zh(?:-|$)/i.test(locale)) return;
  const traditional = /^zh-(?:tw|hk|hant)(?:-|$)/i.test(locale);
  const words = {
    'Your Patina Circle points': ['你的 Patina Circle 积分', '你的 Patina Circle 點數'],
    'Points history': ['积分记录', '點數紀錄'],
    'Points History': ['积分记录', '點數紀錄'],
    'Points canceled - Placed an order': ['积分已取消 — 下单购物', '點數已取消 — 下單購物'],
    'Placed an order': ['下单购物', '下單購物'],
    'Redeemed a Reward': ['兑换奖励', '兌換獎勵'],
    'manual points adjustment': ['手动调整积分', '手動調整點數'],
    'Manual adjustment': ['手动调整', '手動調整'],
    'Upcoming reward': ['下一项奖励', '下一項獎勵'],
    'Patina Circle money off': ['Patina Circle 抵用优惠', 'Patina Circle 折抵優惠'],
    'Rewards': ['积分奖励', '點數獎勵'],
    'Your rewards': ['你的奖励', '你的獎勵'],
    'Past rewards': ['已兑换的奖励', '已兌換的獎勵'],
    'Ways to earn': ['如何累积积分', '如何累積點數'],
    'Ways to redeem': ['如何兑换优惠', '如何兌換優惠'],
    'Back': ['返回', '返回'],
    'Close': ['关闭', '關閉'],
    'Place an order': ['下单购物', '下單購物'],
    '10 Points for every $1 you spend': ['每消费 $1 可获 10 积分', '每消費 $1 可獲 10 點'],
    '10 points per $1. Every 500 points = $5 off.': ['每消费 $1 可获 10 积分，每 500 积分可兑换 $5 优惠。', '每消費 $1 可獲 10 點，每 500 點可兌換 $5 優惠。'],
    'One Patina Studio account': ['一个 Patina Studio 账户即可', '一個 Patina Studio 帳號即可'],
    'Already signed up with us?': ['已经有账户了？', '已經有帳號了？'],
    'Continue with email': ['使用邮箱继续', '使用電子郵件繼續'],
    'Sign in': ['登录', '登入'],
    'Signup': ['注册', '註冊'],
    'Earn with every purchase': ['购物即可累积积分', '購物即可累積點數'],
    'Earn on your subtotal after discounts, before tax and shipping.': ['积分按折扣后的商品小计计算，不含税费和运费。', '點數按折扣後的商品小計計算，不含稅費和運費。'],
    'Points': ['积分', '點數'],
    'Point': ['积分', '點數']
  };
  const protectedSelector = [
    'script', 'style', 'noscript', 'textarea', 'input', 'select', 'option', 'code', 'pre',
    '[contenteditable]:not([contenteditable="false"])', '[translate="no"]',
    '[data-ps-circle-no-translate]', '[data-coupon-code]', '[data-discount-code]',
    '[data-customer-name]', '[data-customer-email]',
    '[class*="coupon-code"]', '[class*="discount-code"]', '[class*="customer-name"]',
    '[class*="customer-email"]', '[class*="customer__name"]', '[class*="customer__email"]'
  ].join(',');
  const frames = new WeakMap();
  function translate(value) {
    const key = value.trim();
    let result = Object.prototype.hasOwnProperty.call(words, key) ? words[key][traditional ? 1 : 0] : '';
    if (!result) {
      let match = key.match(/^([+-]\s*)?(\d[\d,]*(?:\.\d+)?)\s+Points?$/);
      if (match) result = `${match[1] || ''}${match[2]} ${traditional ? '點' : '积分'}`;
      else {
        match = key.match(/^(\d[\d,]*(?:\.\d+)?)\s+Points?\s*=\s*(\$\d[\d,]*(?:\.\d+)?)$/);
        if (match) result = `${match[1]} ${traditional ? '點' : '积分'} = ${match[2]}`;
      }
    }
    if (!result) {
      let match = key.match(/^(\$\d[\d,]*(?:\.\d+)?) off coupon$/);
      if (match) result = `${match[1]} ${traditional ? '折抵優惠券' : '抵用优惠券'}`;
      else {
        match = key.match(/^Spent (\d[\d,]*(?:\.\d+)?) Points?$/);
        if (match) result = traditional ? `已使用 ${match[1]} 點` : `已使用 ${match[1]} 积分`;
      }
    }
    if (!result) {
      const date = key.match(/^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0?[1-9]|[12]\d|3[01]), (\d{4})$/);
      if (date) {
        const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].indexOf(date[1]) + 1;
        result = `${date[3]}年${month}月${date[2]}日`;
      }
    }
    return result ? value.match(/^\s*/)[0] + result + value.match(/\s*$/)[0] : value;
  }
  function protectedNode(element) {
    return !element || element.closest(protectedSelector);
  }
  function translateText(node) {
    if (protectedNode(node.parentElement)) return;
    const next = translate(node.nodeValue || '');
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function translateAria(element) {
    if (protectedNode(element)) return;
    for (const name of ['aria-label', 'aria-description']) {
      const old = element.getAttribute(name);
      if (old === null) continue;
      const next = translate(old);
      if (next !== old) element.setAttribute(name, next);
    }
  }
  function translateEarnRule(element) {
    if (!element || !element.matches('div.less-color') || protectedNode(element)) return;
    const children = Array.from(element.childNodes);
    const spans = children.filter(node => node.nodeType === 1);
    if (spans.length !== 1 || children.some(node => node.nodeType !== 1 && node.nodeType !== 3)) return;
    const last = spans[0];
    if (!last.matches('span.text-lowercase') || last.children.length || last.childNodes.length !== 1 || last.firstChild.nodeType !== 3) return;
    const textNodes = children.filter(node => node.nodeType === 3);
    const prefix = textNodes.map(node => node.nodeValue).join('').trim();
    const unit = traditional ? '點／每' : '积分／每';
    const suffix = traditional ? '消費' : '消费';
    if (prefix !== '10 Points for every $1' && prefix !== `10 ${unit} $1`) return;
    if (last.textContent.trim() !== 'you spend' && last.textContent.trim() !== suffix) return;
    // React splits this observed sentence into adjacent text nodes. Keep those nodes,
    // numeric fragments and the span in place; only translate the wording fragments.
    for (const node of textNodes) {
      const next = node.nodeValue.replace('Points for every', unit);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    const node = last.firstChild;
    const next = node.nodeValue.replace('you spend', suffix);
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function translateSubtree(root) {
    if (root.nodeType === 3) {
      translateEarnRule(root.parentElement);
      translateEarnRule(root.parentElement?.parentElement);
      translateText(root);
      return;
    }
    if (root.nodeType === 1) { translateEarnRule(root); translateAria(root); }
    const doc = root.ownerDocument || root;
    const walker = doc.createTreeWalker(root, 5); // SHOW_ELEMENT | SHOW_TEXT
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      if (node.nodeType === 3) translateText(node);
      else { translateEarnRule(node); translateAria(node); }
    }
  }
  function connect(frame, state) {
    let doc;
    try { doc = frame.contentDocument; } catch (_) { return; }
    if (!doc || doc === state.doc) return;
    if (state.observer) state.observer.disconnect();
    state.doc = doc;
    const pending = new Set();
    let scheduled = false;
    const enqueue = node => {
      pending.add(node);
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        for (const target of pending) {
          if (target.isConnected && target.ownerDocument === doc) translateSubtree(target);
        }
        pending.clear();
      });
    };
    state.observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'childList') record.addedNodes.forEach(enqueue);
        else enqueue(record.target);
      }
    });
    state.observer.observe(doc, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['aria-label', 'aria-description']});
    translateSubtree(doc);
  }
  function attach(frame) {
    if (frame.tagName !== 'IFRAME' || frame.id !== 'ba-other-window-body') return;
    let state = frames.get(frame);
    if (!state) {
      state = {doc:null, observer:null};
      frames.set(frame, state);
      frame.addEventListener('load', () => connect(frame, state));
    }
    connect(frame, state);
  }
  function findFrames(root) {
    if (root.nodeType === 1 && root.matches('iframe#ba-other-window-body')) attach(root);
    root.querySelectorAll?.('iframe#ba-other-window-body').forEach(attach);
  }
  findFrames(document);
  new MutationObserver(records => {
    for (const record of records) record.addedNodes.forEach(findFrames);
  }).observe(document.documentElement, {childList:true, subtree:true});
})();
